export const getRetailerSearchText = (state) =>
  state.brandStartOrderModal.retailerSearchText
export const getRetailerId = (state) => state.brandStartOrderModal.retailerId
export const getCollectionSearchText = (state) =>
  state.brandStartOrderModal.collectionSearchText
